import { SystemStyleObjectRecord, theme } from '@chakra-ui/react';

export const stylesBySize: Record<string, SystemStyleObjectRecord> = {
  xxs: {
    dialog: {
      maxWidth: '100vw',
      width: '224px',
    },
  },
  xs: {
    dialog: {
      maxWidth: '100vw',
      width: '312px',
    },
  },
  sm: {
    dialog: {
      maxWidth: '100vw',
      width: '448px',
    },
  },
  md: {
    dialog: {
      maxWidth: 'calc(100vw - 96px)',
      width: '552px',
    },
  },
  lg: {
    dialog: {
      maxWidth: 'calc(100vw - 96px)',
      width: '662px',
    },
  },
  xl: {
    dialog: {
      maxWidth: 'calc(100vw - 96px)',
      width: '864px',
    },
  },
  '2xl': {
    dialog: {
      maxWidth: 'calc(100vw - 96px)',
      width: '1024px',
    },
  },
  full: {
    dialogContainer: {
      zIndex: theme.zIndices.toast,
    },
    dialog: {
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      height: '100vh',
      marginTop: '0',
      width: '100vw',
    },
  },
  fullWidth: {
    dialog: {
      width: '100vw',
    },
  },
};

export const getStylesBySize = (size: string): SystemStyleObjectRecord => {
  const styles: SystemStyleObjectRecord = stylesBySize[size] ?? {};

  const { dialog: contentPropsBySize, dialogContainer: containerPropsBySize } =
    styles;

  return { contentPropsBySize, containerPropsBySize };
};
